export default class Style
{
	static get ()
	{
		return {
			defaultInput: "form-control",
			suggestions: "position-absolute list-group",
			suggestItem: "list-group-item",
		};
	}
}